import { c as _c } from "react/compiler-runtime";
import { FiAlertTriangle } from "react-icons/fi";
import { ProgressBarLink } from "@/components/progress-bar";
import { Button } from "@/components/ui";
export function QualiphySetupRequired() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FiAlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-status-warning-text" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><h4 className="text-body-strong text-status-warning-text">Qualiphy setup required</h4><p className="mt-1 text-body text-status-warning-text">Connect this clinic's Qualiphy account before loading exams or sending exam invites.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="rounded-lg border border-status-warning-text bg-status-warning-bg p-4"><div className="flex items-start gap-3">{t0}<div className="space-y-2">{t1}<Button variant="primary" size="sm" asChild={true}><ProgressBarLink href="/settings/qualiphy">Open Qualiphy settings</ProgressBarLink></Button></div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}